import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRecordinAnimate = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={46} height={46} fill='none' {...props}>
    <rect width={18} height={18} x={14} y={14} fill='#F23645' rx={3} />
    <path
      stroke='#fff'
      strokeWidth={3}
      d='M23 44c11.598 0 21-9.402 21-21S34.598 2 23 2 2 11.402 2 23s9.402 21 21 21Z'
      opacity={0.3}
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeWidth={3}
      d='M23 44C11.402 44 2 34.598 2 23S11.402 2 23 2'
    />
  </svg>
);
export default SvgRecordinAnimate;
